import React, {
  useState,
  useEffect,
  useMemo,
  useContext,
  useRef,
  useCallback,
} from "react";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { isNil } from "lodash";
import {
  Fade
} from "@material-ui/core";
import {
  CircularProgress,
  ClickAwayListener,
  IconButton,
  InputBase,
  makeStyles,
  Paper,
  Menu,
  MenuItem,
  Tooltip,
  Chip,
  Box,
} from "@material-ui/core";
import {
  AttachFile,
  Clear,
  Comment,
  Create,
  Description,
  Mic,
  Mood,
  Send,
  PermMedia,
  Person,
  Reply,
  Duo,
  Timer,
  WhatsApp,
  Info,
  AccountTree
} from "@material-ui/icons";

import {
  FormatBold as FormatBoldIcon,
  FormatItalic as FormatItalicIcon,
  FormatStrikethrough as FormatStrikethroughIcon,
  Code as CodeIcon,
  FormatListNumbered as FormatListNumberedIcon,
  FormatListBulleted as FormatListBulletedIcon,
  FormatQuote as FormatQuoteIcon,
  FormatClear as FormatClearIcon,
} from "@material-ui/icons";

import AddIcon from "@material-ui/icons/Add";
import WifiIcon from "@material-ui/icons/Wifi";
import { CameraAlt } from "@material-ui/icons";
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import api, { openApi } from "../../services/api";
import AudioRecorderBar from "./AudioRecorderBar";
import { sendTextOptimistic, sendMediaOptimistic } from "./optimisticSend";
import useMentionCompose from "./useMentionCompose";
import MentionSuggest from "./MentionSuggest";
import useGroupParticipants from "../MessagesList/groupParticipants";
import MentionText from "../MessagesList/MentionText";
import { buildParticipantIndex, describeMention } from "../MessagesList/mentions";

import useQuickMessages from "../../hooks/useQuickMessages";
import useHotspotStatus from "../../hooks/useHotspotStatus";
import { isString, isEmpty } from "lodash";
import ContactSendModal from "../ContactSendModal";
import CameraModal from "../CameraModal";
import SendVoucherDialog from "../SendVoucherDialog";
import axios from "axios";

import useCompanySettings from "../../hooks/useSettings/companySettings";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import MessageUploadMedias from "../MessageUploadMedias";
import { EditMessageContext } from "../../context/EditingMessage/EditingMessageContext";
import ScheduleModal from "../ScheduleModal";
import usePlans from "../../hooks/usePlans";
import TemplateModal from "../TemplateMetaModal";
import TriggerFlowModal from "../TriggerFlowModal";
import { getTokens, brandAlpha, SEMANTIC } from "../../styles/tokens";


const Mp3Recorder = new MicRecorder({
  bitRate: 128,
  sampleRate: 44100
});

// Rascunhos ficam só neste navegador; falha de armazenamento nunca atrapalha o envio.
const draftKey = (ticketId) => `digiteai:draft:${ticketId}`;
const readDraft = (ticketId) => {
  try {
    return localStorage.getItem(draftKey(ticketId)) || "";
  } catch (e) {
    return "";
  }
};
const writeDraft = (ticketId, text) => {
  try {
    if (text && text.trim()) localStorage.setItem(draftKey(ticketId), text);
    else localStorage.removeItem(draftKey(ticketId));
  } catch (e) {
    // sem armazenamento disponível: segue sem rascunho
  }
};

const isMobileDevice = () => {
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// assinatura que o sistema põe no começo da mensagem ("*Nome:*" + quebra de linha)
const EDIT_SIGNATURE_RE = /^\u200e?\*[^*\n]{1,80}:\*\n/;

const useStyles = makeStyles((theme) => {
  const t = getTokens(theme.palette.type, theme.palette.primary.main);
  const isDark = theme.palette.type === "dark";
  // Barra de digitação no padrão do WhatsApp Web: paleta fixa, a mesma família da conversa
  // (faixa cinza, campo claro por cima, ícones cinza, enviar verde).
  const wa = isDark
    ? {
        bar: "#202c33",
        field: "#2a3942",
        icon: "#aebac1",
        text: "#e9edef",
        soft: "#8696a0",
        hover: "rgba(255,255,255,0.08)",
        note: "#3a3418",
        quote: "rgba(11,20,26,0.4)",
        self: "#06cf9c",
        other: "#53bdeb",
        sendOff: "#2a3942",
      }
    : {
        bar: "#f0f2f5",
        field: "#ffffff",
        icon: "#54656f",
        text: "#111b21",
        soft: "#667781",
        hover: "rgba(11,20,26,0.07)",
        note: "#fff8dc",
        quote: "rgba(11,20,26,0.06)",
        self: "#008069",
        other: "#0b7bb8",
        sendOff: "#c5ccd1",
      };
  const waGreen = "#00a884";
  const noteInk = isDark ? "#fbbf24" : "#9a5c09";

  return {
  mainWrapper: {
    background: wa.bar,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "center",
    minHeight: 62,
    padding: "5px 10px",
    border: 0,
    borderRadius: 0,
    position: "relative",
    zIndex: 4,
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      width: "100%",
      left: 0,
      right: 0,
      minHeight: 56,
      padding: "5px 6px calc(5px + env(safe-area-inset-bottom))",
    },
  },
  // No celular a barra é fixa no rodapé e ficava POR CIMA do fim da conversa (a última bolha
  // sumia atrás dela). Este espaçador entra no fluxo com a altura da barra e a lista encolhe.
  mobileBarSpacer: {
    display: "none",
    flex: "none",
    [theme.breakpoints.down("sm")]: { display: "block" },
  },
  newMessageBox: {
    width: "100%",
    minWidth: 0,
    display: "flex",
    alignItems: "flex-end",
    gap: 2,
    position: "relative",
  },
  // botões soltos sobre a faixa (anexar, emoji, microfone, fechar resposta)
  barButton: {
    flex: "none",
    width: 42,
    height: 42,
    padding: 9,
    borderRadius: "50%",
    color: wa.icon,
    transition: "background-color 150ms ease, color 150ms ease",
    "&:hover": { backgroundColor: wa.hover },
    "&.Mui-disabled": { color: wa.icon, opacity: 0.38 },
    "& .MuiSvgIcon-root": {
      fontSize: 26,
      transition: "transform 180ms ease",
    },
  },
  barButtonOpen: {
    backgroundColor: wa.hover,
    "& .MuiSvgIcon-root": { transform: "rotate(45deg)" },
  },
  emojiButton: {
    // no celular o teclado já traz os emojis; o espaço fica para o campo
    [theme.breakpoints.down("xs")]: { display: "none" },
  },
  messageInputWrapper: {
    flex: 1,
    minWidth: 0,
    minHeight: 42,
    margin: "0 4px",
    padding: "0 4px 0 14px",
    display: "flex",
    alignItems: "flex-end",
    borderRadius: 8,
    position: "relative",
    zIndex: 10,
    background: wa.field,
    border: "1px solid transparent",
    transition: "border-color 160ms ease, background-color 160ms ease",
  },
  // nota interna (e ticket aguardando): o campo fica amarelado, como a bolha da nota na conversa
  messageInputWrapperInternal: {
    background: wa.note,
    borderColor: brandAlpha(SEMANTIC.warning, isDark ? 0.5 : 0.45),
  },
  messageInput: {
    flex: 1,
    minWidth: 0,
    padding: "9px 0",
    border: "none",
    color: wa.text,
    fontSize: 15,
    lineHeight: "22px",
    "& input::placeholder, & textarea::placeholder": {
      color: wa.soft,
      opacity: 1,
    },
    "&.Mui-disabled": { color: wa.soft },
  },
  messageInputPending: {
    color: noteInk,
    fontWeight: 500,
  },
  // alternadores dentro do campo (assinatura, nota interna)
  fieldToggle: {
    flex: "none",
    width: 32,
    height: 32,
    padding: 6,
    margin: "4px 0",
    borderRadius: "50%",
    color: wa.soft,
    "&:hover": { backgroundColor: wa.hover },
    "& .MuiSvgIcon-root": { fontSize: 20 },
  },
  fieldToggleOn: {
    color: isDark ? t.accent : t.accentHover,
  },
  fieldToggleNote: {
    color: noteInk,
  },
  sendWrap: {
    flex: "none",
    display: "inline-flex",
  },
  sendButton: {
    flex: "none",
    width: 42,
    height: 42,
    padding: 9,
    borderRadius: "50%",
    backgroundColor: waGreen,
    color: "#ffffff",
    transition: "background-color 150ms ease",
    "&:hover": { backgroundColor: "#008f72" },
    "&.Mui-disabled": {
      backgroundColor: wa.sendOff,
      color: isDark ? wa.soft : "#ffffff",
    },
    "& .MuiSvgIcon-root": { fontSize: 22 },
  },
  // o aviãozinho é assimétrico: 2px à direita o centraliza no círculo
  sendIcon: {
    marginLeft: 3,
  },
  forwardIcon: {
    transform: "scaleX(-1)",
  },
  uploadInput: {
    display: "none",
  },
  // enquanto a prévia do anexo está aberta, a faixa continua no lugar (vazia)
  viewMediaInputWrapper: {
    display: "flex",
    alignItems: "center",
    minHeight: 62,
    padding: "5px 10px",
    position: "relative",
    backgroundColor: wa.bar,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
    [theme.breakpoints.down("sm")]: { minHeight: 0, padding: 0 },
  },
  emojiBox: {
    position: "absolute",
    left: 8,
    bottom: "calc(100% + 6px)",
    border: 0,
    zIndex: 1200,
    "& .emoji-mart": { maxWidth: "calc(100vw - 16px)" },
  },
  // resposta/edição: bloco com filete colorido, nome e trecho; o "X" fica na coluna do enviar
  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    gap: 2,
    padding: "2px 0 6px",
  },
  replyginMsgContainer: {
    flex: 1,
    minWidth: 0,
    margin: "0 4px",
    overflow: "hidden",
    backgroundColor: wa.quote,
    borderRadius: 8,
    display: "flex",
    position: "relative",
  },
  replyginMsgBody: {
    flex: 1,
    minWidth: 0,
    padding: "7px 12px 8px",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    fontSize: 13.2,
    lineHeight: "19px",
    color: wa.soft,
  },
  replyginMsgText: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  replyginContactMsgSideColor: {
    flex: "none",
    width: 4,
    backgroundColor: wa.other,
  },
  replyginSelfMsgSideColor: {
    backgroundColor: wa.self,
  },
  replyginTitleIcon: {
    fontSize: 14,
  },
  messageContactName: {
    display: "flex",
    alignItems: "center",
    gap: 5,
    minWidth: 0,
    fontSize: 12.8,
    fontWeight: 600,
    color: wa.other,
  },
  messageSelfName: {
    color: wa.self,
  },
  floatingFormatMenu: {
    position: 'fixed',
    backgroundColor: t.paper,
    borderRadius: t.radius.sm,
    boxShadow: t.shadow.lift,
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '4px',
    border: `1px solid ${t.line}`,
  },

  formatIconButton: {
    padding: '6px',
    borderRadius: 8,
    minWidth: '32px',
    height: '32px',
  },
  messageQuickAnswersWrapper: {
    margin: "0 0 8px",
    position: "absolute",
    bottom: "100%", // acima do campo
    background: t.paper,
    padding: 4,
    border: `1px solid ${t.line}`,
    left: 0,
    right: 0,
    maxHeight: "200px",
    overflowY: "auto",
    overflowX: "hidden",
    boxShadow: t.shadow.lift,
    borderRadius: t.radius.sm,
    zIndex: 1000,
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: "3px",
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
    "& li": {
      listStyle: "none",
    },
  },
  quickAnswerItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: "8px 12px",
    minHeight: 40,
    cursor: "pointer",
    borderRadius: t.radius.badge,
    borderLeft: "3px solid transparent",
    margin: "1px 0",
    fontSize: 14,
    color: t.text,
    "&:hover": {
      backgroundColor: t.muted,
    },
    transition: "background-color 150ms ease",
  },

  // item escolhido pelo teclado (↑ ↓)
  quickAnswerItemSelected: {
    backgroundColor: t.accentTint.soft,
    borderLeftColor: t.accent,
    fontWeight: 500,
    "&:hover": {
      backgroundColor: t.accentTint.soft,
    },
  },

  quickAnswersScrollIndicator: {
    textAlign: "center",
    padding: "6px 8px",
    fontSize: 12,
    color: t.textSecondary,
    borderTop: `1px solid ${t.line}`,
    backgroundColor: t.paper,
  },
  quickAnswerText: {
    flex: 1,
    minWidth: 0,
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  mediaTypeChip: {
    height: 20,
    fontSize: "0.7rem",
  },
  // menu do "+": lista com ícone colorido à esquerda, como o do WhatsApp
  attachMenuPaper: {
    marginTop: -8,
  },
  attachMenuList: {
    padding: 6,
    minWidth: 220,
  },
  attachItem: {
    minHeight: 42,
    gap: 12,
    padding: "5px 16px 5px 8px",
    fontSize: 14.5,
    color: t.text,
  },
  attachIcon: {
    flex: "none",
    width: 32,
    height: 32,
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiSvgIcon-root": { fontSize: 19 },
  },
  menuCaption: {
    listStyle: "none",
    margin: "6px 0 2px",
    padding: "10px 10px 2px",
    borderTop: `1px solid ${t.line}`,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: t.textMuted,
  },
  pendingAlert: {
    margin: "2px 4px 6px",
    padding: "6px 12px",
    backgroundColor: brandAlpha(SEMANTIC.warning, isDark ? 0.16 : 0.1),
    border: `1px solid ${brandAlpha(SEMANTIC.warning, 0.3)}`,
    borderRadius: t.radius.sm,
    display: "flex",
    alignItems: "center",
    gap: 8,
    color: isDark ? wa.text : "#6b4a0a",
    fontSize: 12.5,
    lineHeight: 1.4,
    "& > svg": { flex: "none", color: noteInk },
  },
  flowAlert: {
    backgroundColor: t.accentTint.soft,
    borderColor: brandAlpha(t.accent, 0.35),
    color: t.textSecondary,
  },
  };
});

const MessageInput = ({
  ticketId,
  ticketStatus,
  droppedFiles,
  contactId,
  ticketChannel,
  whatsappId,
  isGroup,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const tokens = getTokens(theme.palette.type, theme.palette.primary.main);
  const [mediasUpload, setMediasUpload] = useState([]);
  const isMounted = useRef(true);

  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [templateModalOpen, setTemplateModalOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const inputRef = useRef();
  const barRef = useRef(null);
  const [barHeight, setBarHeight] = useState(0);
  const mediaInputRef = useRef(null);
  const docInputRef = useRef(null);
  const quickAnswersRef = useRef(null);
  const [onDragEnter, setOnDragEnter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { setReplyingMessage, replyingMessage } =
    useContext(ReplyMessageContext);
  const { setEditingMessage, editingMessage } = useContext(EditMessageContext);
  const editSignatureRef = useRef("");
  const { user } = useContext(AuthContext);
  const [appointmentModalOpen, setAppointmentModalOpen] = useState(false);
  const { getPlanCompany } = usePlans();

  const [signMessagePar, setSignMessagePar] = useState(false);
  const { get: getSetting } = useCompanySettings();
  const [signMessage, setSignMessage] = useState(true);
  const [privateMessage, setPrivateMessage] = useState(false);
  const [privateMessageInputVisible, setPrivateMessageInputVisible] =
    useState(false);
  const [senVcardModalOpen, setSenVcardModalOpen] = useState(false);
  const [showModalMedias, setShowModalMedias] = useState(false);
  const [showSchedules, setShowSchedules] = useState(false);
  const [useWhatsappOfficial, setUseWhatsappOfficial] = useState(false);
  const { list: listQuickMessages } = useQuickMessages();

  const isMobile = useMediaQuery("(max-width: 767px)");
  const [placeholderText, setPlaceHolderText] = useState("");

  const [selectedQuickAnswerIndex, setSelectedQuickAnswerIndex] = useState(-1);
  const [isNavigatingQuickAnswers, setIsNavigatingQuickAnswers] = useState(false);

  const [triggerFlowModalOpen, setTriggerFlowModalOpen] = useState(false);
  const [flowProcessing, setFlowProcessing] = useState(false);
  const flowProcessingRef = useRef(false);

  const [sendVoucherModalOpen, setSendVoucherModalOpen] = useState(false);
  const { enabled: hotspotEnabled } = useHotspotStatus();

  const [formatMenuAnchorPosition, setFormatMenuAnchorPosition] = useState(null);
  const [selectedText, setSelectedText] = useState({ text: '', start: 0, end: 0 });

  const isTicketPending = () => {
    return ticketStatus === "pending";
  };

  useEffect(() => {
    if (isTicketPending()) {
      setPrivateMessage(true);
      setPrivateMessageInputVisible(true);
    }
  }, [ticketStatus]);

  useEffect(() => {
    async function fetchTemplates() {
      const templates = await api.request({
        url: `/quick-messages/list`,
        method: "GET",
        params: {
          isOficial: "true",
          userId: user.id,
          companyId: user.companyId,
          status: "APPROVED",
          // whatsappId,
        },
      });
      setTemplates(templates.data);
    }
    if (useWhatsappOfficial) {
      fetchTemplates();
    }
  }, [useWhatsappOfficial]);

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      setShowSchedules(planConfigs.plan.useSchedules);
      setUseWhatsappOfficial(planConfigs.plan.useWhatsappOfficial);
    }
    fetchData();
  }, []);

  useEffect(() => {
    // O texto é montado antes de cortar: no celular o corte usava o valor antigo do estado e a
    // conversa aberta ficava com o aviso de "reabra ou aceite".
    let text;
    if (ticketStatus === "open" || ticketStatus === "group") {
      text = i18n.t("messagesInput.placeholderOpen");
    } else if (ticketStatus === "pending") {
      text = "Digite sua mensagem interna (ticket aguardando)...";
    } else {
      text = i18n.t("messagesInput.placeholderClosed");
    }

    const maxLength = isMobile ? 20 : Infinity;

    if (isMobile && text.length > maxLength) {
      text = text.substring(0, maxLength) + "...";
    }
    setPlaceHolderText(text);
  }, [ticketStatus]);

  const {
    selectedMessages,
    setForwardMessageModalOpen,
    showSelectMessageCheckbox,
  } = useContext(ForwardMessageContext);

  useEffect(() => {
    if (droppedFiles && droppedFiles.length > 0) {
      const selectedMedias = Array.from(droppedFiles);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  }, [droppedFiles]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  // acompanha a altura da barra (resposta, aviso de ticket aguardando, várias linhas…)
  const hasMediasPreview = mediasUpload.length > 0 && showModalMedias;
  useEffect(() => {
    const bar = barRef.current;
    if (!bar) return undefined;
    const measure = () => setBarHeight(bar.offsetHeight || 0);
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(bar);
    return () => observer.disconnect();
  }, [hasMediasPreview]);

  useEffect(() => {
    inputRef.current.focus();
    if (editingMessage) {
      // a assinatura "*Nome:*" não é editável: sai do campo e volta igual ao salvar
      const signature = (editingMessage.body || "").match(EDIT_SIGNATURE_RE);
      editSignatureRef.current = signature ? signature[0] : "";
      setInputMessage((editingMessage.body || "").slice(editSignatureRef.current.length));
    }
  }, [replyingMessage, editingMessage]);

  // Rascunho por conversa: o texto digitado e não enviado volta ao reabrir a conversa.
  const draftRef = useRef({ text: "", editing: false });
  useEffect(() => {
    draftRef.current = { text: inputMessage, editing: !!editingMessage };
  }, [inputMessage, editingMessage]);

  useEffect(() => {
    inputRef.current.focus();
    const saved = readDraft(ticketId);
    if (saved) setInputMessage(saved);
    return () => {
      if (!draftRef.current.editing) writeDraft(ticketId, draftRef.current.text);
      setInputMessage("");
      setShowEmoji(false);
      setMediasUpload([]);
      setReplyingMessage(null);
      if (!isTicketPending()) {
        setPrivateMessage(false);
        setPrivateMessageInputVisible(false);
      }
      setEditingMessage(null);
    };
  }, [ticketId, setReplyingMessage, setEditingMessage]);


  useEffect(() => {
    let isProcessing = false; // ✅ Flag para evitar processamento duplo

    const handleInsertQuickMessage = (event) => {
      // ✅ IMPORTANTE: Evitar processamento duplo
      if (isProcessing) {
        console.log("⚠️ Já processando evento, ignorando...");
        return;
      }

      isProcessing = true;
      console.log("📥 Evento insertQuickMessage recebido:", event.detail);

      const { quickMessage } = event.detail;

      if (!quickMessage) {
        console.error("❌ quickMessage não encontrado no evento");
        isProcessing = false;
        return;
      }

      console.log("🔍 Processando quickMessage:", {
        hasMedia: !!quickMessage.mediaPath,
        mediaType: quickMessage.mediaType,
        message: quickMessage.message,
        ticketId: ticketId
      });

      if (quickMessage.mediaPath) {
        console.log("🎵 Processando resposta rápida com mídia");
        handleQuickAnswersClick({
          value: quickMessage.message || "",
          mediaPath: quickMessage.mediaPath,
          mediaType: quickMessage.mediaType,
          shortcode: quickMessage.shortcode,
          label: `/${quickMessage.shortcode} - ${quickMessage.message}`
        }).finally(() => {
          isProcessing = false; // ✅ Liberar flag após processamento
        });
      } else {
        console.log("📝 Processando resposta rápida de texto");
        const currentText = inputMessage?.trim() || "";
        const newText = currentText
          ? `${currentText}\n\n${quickMessage.message}`
          : quickMessage.message;

        setInputMessage(newText);

        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
            const length = newText.length;
            inputRef.current.setSelectionRange(length, length);
          }
          isProcessing = false; // ✅ Liberar flag
        }, 100);
      }
    };

    // ✅ IMPORTANTE: Escutar apenas no window
    window.addEventListener('insertQuickMessage', handleInsertQuickMessage);

    return () => {
      window.removeEventListener('insertQuickMessage', handleInsertQuickMessage);
      isProcessing = false; // ✅ Reset da flag no cleanup
    };
  }, [inputMessage, ticketId, privateMessage]);

  useEffect(() => {
    setTimeout(() => {
      if (isMounted.current) setOnDragEnter(false);
    }, 1000);
  }, [onDragEnter === true]);

  useEffect(() => {
    const fetchSettings = async () => {
      const setting = await getSetting({
        column: "sendSignMessage",
      });

      if (isMounted.current) {
        if (setting.sendSignMessage === "enabled") {
          setSignMessagePar(true);
          const signMessageStorage = JSON.parse(
            localStorage.getItem("persistentSignMessage")
          );
          if (isNil(signMessageStorage)) {
            setSignMessage(true);
          } else {
            setSignMessage(signMessageStorage);
          }
        } else if (setting.sendSignMessage === "dontSend") {
          localStorage.setItem("persistentSignMessage", false);
          setSignMessage(false);
          setSignMessagePar(false);
        } else {
          setSignMessagePar(false);
        }
      }
    };
    fetchSettings();
  }, []);

  // CORREÇÃO DO ERRO charAt - Função mais robusta
  const safeCapitalizeFirstLetter = (string) => {
    if (!string || typeof string !== 'string') return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  // FUNÇÕES PARA TRIGGER FLOW MODAL
  const handleTriggerFlowClick = useCallback(() => {
    console.log("🎯 Abrindo modal de fluxo");

    // 🛡️ RESET PREVENTIVO
    setFlowProcessing(false);
    flowProcessingRef.current = false;

    setTriggerFlowModalOpen(true);
  }, []);

  const handleTriggerFlowClose = useCallback(() => {
    console.log("🚪 Fechando modal");

    setFlowProcessing(false);
    flowProcessingRef.current = false;
    setTriggerFlowModalOpen(false);
  }, []);

  const handleFlowProcessing = useCallback((isProcessing) => {
    console.log("🔄 Flow processing:", isProcessing);
    setFlowProcessing(isProcessing);
    flowProcessingRef.current = isProcessing;

    // 🔥 TIMEOUT SIMPLES: 8 segundos e libera SEM PERGUNTAR
    if (isProcessing) {
      setTimeout(() => {
        console.log("⏰ TIMEOUT - Liberando campo FORÇADO");
        setFlowProcessing(false);
        flowProcessingRef.current = false;
      }, 8000);
    }
  }, []);

  const handleFlowTriggered = useCallback((data) => {
    console.log("✅ Fluxo concluído");

    // 🔥 RESET IMEDIATO - SEM TIMEOUT
    setFlowProcessing(false);
    flowProcessingRef.current = false;
  }, []);


  // NAVEGAÇÃO POR TECLADO CORRIGIDA
  const handleKeyDown = useCallback((e) => {
    if (!typeBar || !Array.isArray(typeBar) || typeBar.length === 0) {
      setSelectedQuickAnswerIndex(-1);
      setIsNavigatingQuickAnswers(false);
      return;
    }

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setIsNavigatingQuickAnswers(true);
        setSelectedQuickAnswerIndex(prev => {
          const nextIndex = prev < typeBar.length - 1 ? prev + 1 : 0;

          // SCROLL AUTOMÁTICO CORRIGIDO
          setTimeout(() => {
            const container = quickAnswersRef.current;
            if (container) {
              const selectedElement = container.children[nextIndex];
              if (selectedElement) {
                selectedElement.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest'
                });
              }
            }
          }, 0);

          return nextIndex;
        });
        break;

      case 'ArrowUp':
        e.preventDefault();
        setIsNavigatingQuickAnswers(true);
        setSelectedQuickAnswerIndex(prev => {
          const nextIndex = prev > 0 ? prev - 1 : typeBar.length - 1;

          // SCROLL AUTOMÁTICO CORRIGIDO
          setTimeout(() => {
            const container = quickAnswersRef.current;
            if (container) {
              const selectedElement = container.children[nextIndex];
              if (selectedElement) {
                selectedElement.scrollIntoView({
                  behavior: 'smooth',
                  block: 'nearest'
                });
              }
            }
          }, 0);

          return nextIndex;
        });
        break;

      case 'Enter':
        if (isNavigatingQuickAnswers && selectedQuickAnswerIndex >= 0) {
          e.preventDefault();
          const selectedAnswer = typeBar[selectedQuickAnswerIndex];
          handleQuickAnswersClick(selectedAnswer);
          setSelectedQuickAnswerIndex(-1);
          setIsNavigatingQuickAnswers(false);
        }
        break;

      case 'Escape':
        if (isNavigatingQuickAnswers) {
          e.preventDefault();
          setSelectedQuickAnswerIndex(-1);
          setIsNavigatingQuickAnswers(false);
          setTypeBar(false);
        }
        break;

      case 'Tab':
        if (isNavigatingQuickAnswers) {
          e.preventDefault();
          setSelectedQuickAnswerIndex(prev => {
            const nextIndex = prev < typeBar.length - 1 ? prev + 1 : 0;
            return nextIndex;
          });
        }
        break;

      default:
        if (isNavigatingQuickAnswers && e.key.length === 1) {
          setSelectedQuickAnswerIndex(-1);
          setIsNavigatingQuickAnswers(false);
        }
        break;
    }
  }, [typeBar, selectedQuickAnswerIndex, isNavigatingQuickAnswers]);

  useEffect(() => {
    if (!typeBar || !Array.isArray(typeBar) || typeBar.length === 0) {
      setSelectedQuickAnswerIndex(-1);
      setIsNavigatingQuickAnswers(false);
    }
  }, [typeBar]);

  const handleSendLinkVideo = async () => {
    const link = `https://meet.jit.si/${ticketId}`;
    setInputMessage(link);
  };

  const handleSendTemplate = async () => {
    setTemplateModalOpen(true);
  };

  // Grupo: digitar "@" abre a lista de participantes para marcar alguém (não vale para nota
  // interna nem para edição, que não chegam ao WhatsApp como mensagem nova).
  const { participants: groupParticipants } = useGroupParticipants(isGroup && contactId ? contactId : null);
  const mention = useMentionCompose({
    enabled: !!isGroup && ticketStatus !== "pending" && !privateMessage && !editingMessage,
    ticketId,
    participants: groupParticipants,
    value: inputMessage,
    setValue: setInputMessage,
    inputRef,
  });
  const mentionIndex = useMemo(() => buildParticipantIndex(groupParticipants), [groupParticipants]);
  const resolveQuotedMention = isGroup
    ? (digits) =>
        describeMention(digits, {
          participant: mentionIndex.get(digits) || null,
          mentioned: null,
          fallbackLabel: i18n.t("conversation.mentions.participant"),
        })
    : null;

  const handleChangeInput = (e) => {
    setInputMessage(e.target.value);
    mention.track(e.target);
  };

  // "Digitando…" para o cliente (WhatsApp não oficial, ticket em atendimento). Nota interna,
  // edição e resposta rápida ("/") não avisam. O servidor decide se envia (opção da empresa e
  // só o dono do ticket), aqui só evitamos chamadas repetidas.
  const typingRef = useRef({ state: "paused", last: 0, timer: null, ticketId: null });
  useEffect(() => {
    const ref = typingRef.current;
    const send = (state, id = ticketId) => {
      ref.state = state;
      ref.last = Date.now();
      ref.ticketId = id;
      api.post(`/tickets/${id}/presence`, { state }).catch(() => {});
    };
    clearTimeout(ref.timer);

    const text = (inputMessage || "").trim();
    const canShow =
      (ticketChannel === "whatsapp" || ticketChannel === "webchat") && ticketStatus === "open" && !privateMessage && !editingMessage;
    const next = !canShow
      ? "paused"
      : recording
        ? "recording"
        : text && !text.startsWith("/")
          ? "composing"
          : "paused";

    if (next === "paused") {
      if (ref.state !== "paused") send("paused");
      return undefined;
    }
    if (ref.state !== next || Date.now() - ref.last > 4000) send(next);
    // parou de digitar sem enviar: depois de alguns segundos o "digitando…" some para o cliente
    if (next === "composing") ref.timer = setTimeout(() => send("paused"), 6000);
    return undefined;
  }, [inputMessage, recording, privateMessage, editingMessage, ticketStatus, ticketChannel, ticketId]);

  // trocou de conversa (ou saiu da tela) no meio da digitação: encerra o aviso na conversa anterior
  useEffect(() => {
    const ref = typingRef.current;
    return () => {
      clearTimeout(ref.timer);
      if (ref.state !== "paused" && ref.ticketId) {
        api.post(`/tickets/${ref.ticketId}/presence`, { state: "paused" }).catch(() => {});
      }
      ref.state = "paused";
    };
  }, [ticketId]);

  const handlePrivateMessage = (e) => {
    if (isTicketPending()) {
      return;
    }
    setPrivateMessage(!privateMessage);
    setPrivateMessageInputVisible(!privateMessageInputVisible);
  };

  const getMediaTypeIcon = (mediaType) => {
    switch (mediaType) {
      case 'audio': return '🎵';
      case 'image': return '🖼️';
      case 'video': return '🎥';
      case 'document': return '📎';
      default: return '📎';
    }
  };

  const getMediaTypeColor = (mediaType) => {
    switch (mediaType) {
      case 'audio': return 'secondary';
      case 'image': return 'primary';
      case 'video': return 'default';
      case 'document': return 'default';
      default: return 'default';
    }
  };

  const handleQuickAnswersClick = useCallback(async (value) => {
    // ✅ IMPORTANTE: Evitar múltiplas execuções simultâneas
    if (loading) {
      console.log("⚠️ Já processando, ignorando clique...");
      return;
    }

    console.log("🎯 handleQuickAnswersClick chamado:", value);
    console.log("📋 ticketId atual:", ticketId);

    if (!ticketId) {
      console.error("❌ ticketId não encontrado");
      toastError("Erro: ID do ticket não encontrado");
      return;
    }

    if (value.mediaPath) {
      try {
        setLoading(true);
        console.log("📥 Baixando mídia:", value.mediaPath);

        const response = await api.get(value.mediaPath, {
          responseType: "blob",
        });

        console.log("✅ Mídia baixada com sucesso, tamanho:", response.data.size);

        const messageBody = value.value && value.value.trim() !== "" ? value.value : "";

        await handleUploadQuickMessageMedia(response.data, messageBody, value.mediaType);

        console.log("✅ Mídia enviada com sucesso");

        setInputMessage("");
        setTypeBar(false);
        return;
      } catch (err) {
        console.error("❌ Erro ao processar mídia:", err);
        toastError(err);
      } finally {
        setLoading(false);
      }
    } else {
      // Para mensagens de texto
      setInputMessage(value.value || "");
      setTypeBar(false);
    }
  }, [loading, ticketId, privateMessage]);

  const handleUploadQuickMessageMedia = useCallback(async (blob, message, mediaType = null) => {
    console.log("📤 Iniciando upload de mídia:", {
      blobSize: blob.size,
      message,
      mediaType,
      ticketId
    });

    if (!ticketId) {
      throw new Error("ID do ticket não encontrado");
    }

    // ✅ IMPORTANTE: Verificar se já está enviando
    if (loading) {
      console.log("⚠️ Upload já em andamento, ignorando...");
      return;
    }

    try {
      let extension = 'bin';

      if (blob.type) {
        const mimeType = blob.type.split("/")[1];
        extension = mimeType;

        if (blob.type.includes('webm') || blob.type.includes('audio')) {
          extension = blob.type.includes('webm') ? 'webm' : 'mp3';
        }
      } else if (mediaType) {
        const typeExtensionMap = {
          'audio': 'webm',
          'image': 'jpg',
          'video': 'mp4',
          'document': 'pdf'
        };
        extension = typeExtensionMap[mediaType] || 'bin';
      }

      const formData = new FormData();
      const filename = `${new Date().getTime()}.${extension}`;
      formData.append("medias", blob, filename);
      formData.append("typeArch", "quickMessage");

      const body = message && message.trim() !== ""
        ? ((privateMessage || isTicketPending()) ? `\u200d${message}` : message)
        : ((privateMessage || isTicketPending()) ? `\u200d` : "");

      formData.append("body", body);
      formData.append("fromMe", true);
      formData.append("isPrivate", (privateMessage || isTicketPending()) ? "true" : "false");

      console.log("📤 Enviando para:", `/messages/${ticketId}`);

      if (isMounted.current) {
        const response = await api.post(`/messages/${ticketId}`, formData);
        console.log("✅ Upload realizado com sucesso:", response.status);
      }
    } catch (err) {
      console.error("❌ Erro no upload:", err);
      toastError(err);
      throw err;
    }
  }, [ticketId, privateMessage, loading]);

  const handleAddEmoji = (e) => {
    let emoji = e.native;
    setInputMessage((prevState) => prevState + emoji);
  };

  const [modalCameraOpen, setModalCameraOpen] = useState(false);

  const handleCapture = (imageData) => {
    if (imageData) {
      handleUploadCamera(imageData);
    }
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }
    const selectedMedias = Array.from(e.target.files);
    setMediasUpload(selectedMedias);
    setShowModalMedias(true);
  };

  const handleChangeSign = (e) => {
    getStatusSingMessageLocalstogare();
  };

  const handleOpenModalForward = () => {
    if (selectedMessages.length === 0) {
      setForwardMessageModalOpen(false);
      toastError(i18n.t("messagesList.header.notMessage"));
      return;
    }
    setForwardMessageModalOpen(true);
  };

  const getStatusSingMessageLocalstogare = () => {
    const signMessageStorage = JSON.parse(
      localStorage.getItem("persistentSignMessage")
    );
    if (signMessageStorage !== null) {
      if (signMessageStorage) {
        localStorage.setItem("persistentSignMessage", false);
        setSignMessage(false);
      } else {
        localStorage.setItem("persistentSignMessage", true);
        setSignMessage(true);
      }
    } else {
      localStorage.setItem("persistentSignMessage", false);
      setSignMessage(false);
    }
  };

  const handleInputPaste = (e) => {
    if (e.clipboardData.files[0]) {
      const selectedMedias = Array.from(e.clipboardData.files);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  };

  const handleInputDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files[0]) {
      const selectedMedias = Array.from(e.dataTransfer.files);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  };

  const handleUploadMedia = (mediasUpload) => {
    if (!mediasUpload.length) {
      return;
    }

    // A prévia fecha na hora e cada anexo vira uma bolha "enviando" na conversa, com o
    // progresso do envio; o campo de mensagem continua livre para o atendente seguir digitando.
    const isPrivate = privateMessage || isTicketPending();
    setMediasUpload([]);
    setShowModalMedias(false);

    sendMediaOptimistic({
      ticketId,
      isPrivate,
      items: mediasUpload.map((media) => ({
        file: media.file,
        fileName: media.file && media.file.name,
        caption: media.caption || "",
      })),
      buildFormData: (items) => {
        const formData = new FormData();
        formData.append("fromMe", true);
        formData.append("isPrivate", isPrivate ? "true" : "false");
        // áudio escolhido no seletor é arquivo de áudio, não mensagem de voz
        if (items.some((item) => String((item.file && item.file.type) || "").startsWith("audio/"))) {
          formData.append("isVoiceNote", "false");
        }
        items.forEach((item) => {
          formData.append("body", item.caption);
          formData.append("medias", item.file);
        });
        return formData;
      },
    });

    if (!isTicketPending()) {
      setPrivateMessage(false);
      setPrivateMessageInputVisible(false);
    }
  };

  const handleSendContatcMessage = async (vcard) => {
    setSenVcardModalOpen(false);
    setLoading(true);

    if (isNil(vcard)) {
      setLoading(false);
      return;
    }

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body: null,
      quotedMsg: replyingMessage,
      isPrivate: (privateMessage || isTicketPending()) ? "true" : "false",
      vCard: vcard,
    };
    try {
      await api.post(`/messages/${ticketId}`, message);
    } catch (err) {
      toastError(err);
    }

    setInputMessage("");
    setShowEmoji(false);
    setLoading(false);
    setReplyingMessage(null);
    setEditingMessage(null);
    if (!isTicketPending()) {
      setPrivateMessage(false);
      setPrivateMessageInputVisible(false);
    }
  };

  const handleSendMessage = async () => {
    if (!inputMessage || inputMessage.trim() === "") return;

    const userName = (privateMessage || isTicketPending())
      ? `${user.name} - Mensagem Interna`
      : user.name;

    // "@Nome" escolhido na lista vira "@<id>" e os marcados vão no campo `mentions`
    const mentioned = editingMessage
      ? { body: `${editSignatureRef.current}${inputMessage.trim()}`, mentions: [] }
      : mention.resolve(inputMessage.trim());
    const sendMessage = mentioned.body;

    const message = {
      read: 1,
      fromMe: true,
      mediaUrl: "",
      body:
        ((signMessage && !isTicketPending()) || privateMessage || isTicketPending()) && !editingMessage
          ? `*${userName}:*\n${sendMessage}`
          : sendMessage,
      quotedMsg: replyingMessage,
      isPrivate: (privateMessage || isTicketPending()) ? "true" : "false",
    };
    if (mentioned.mentions.length > 0) message.mentions = mentioned.mentions;

    if (editingMessage !== null) {
      setLoading(true);
      try {
        await api.post(`/messages/edit/${editingMessage.id}`, message);
      } catch (err) {
        toastError(err);
      }
      setLoading(false);
    } else {
      // Mensagem nova não espera o servidor: entra na conversa como "enviando" e a barra
      // fica livre na hora (se o envio falhar, a própria bolha oferece "Tentar de novo").
      sendTextOptimistic({ ticketId, payload: message });
      mention.reset();
    }

    setInputMessage("");
    setShowEmoji(false);
    setReplyingMessage(null);
    if (!isTicketPending()) {
      setPrivateMessage(false);
    }
    setEditingMessage(null);
    if (!isTicketPending()) {
      setPrivateMessageInputVisible(false);
    }
    handleMenuItemClick();
  };

  const handleSendMessageTemplate = async (e) => {
    if (e.id === "") return;
    setLoading(true);

    const message = {
      templateId: e.id,
      variables: e.variables,
      bodyToSave: e.bodyToSave,
      mediaUrl: "",
      quotedMsg: replyingMessage,
    };

    try {
      await api.post(`/messages-template/${ticketId}`, message);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
    setTemplateModalOpen(false);
    setInputMessage("");
    setShowEmoji(false);
    setReplyingMessage(null);
    if (!isTicketPending()) {
      setPrivateMessage(false);
    }
    setEditingMessage(null);
    if (!isTicketPending()) {
      setPrivateMessageInputVisible(false);
    }
    handleMenuItemClick();
  };

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      // pede a permissão; o fluxo de teste é solto em seguida (a biblioteca abre o dela) —
      // sem isso o microfone continuava "em uso" depois de a gravação terminar
      const probe = await navigator.mediaDevices.getUserMedia({ audio: true });
      probe.getTracks().forEach((track) => track.stop());
      await Mp3Recorder.start();
      setRecording(true);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const messages = await listQuickMessages({
        companyId,
        userId: user.id,
        isOficial: ticketChannel === "whatsapp_oficial" ? "true" : "false",
      });
      const options = messages.map((m) => {
        let truncatedMessage = m.message;
        if (isString(truncatedMessage) && truncatedMessage.length > 90) {
          truncatedMessage = m.message.substring(0, 90) + "...";
        }
        return {
          value: m.message,
          label: `/${m.shortcode} - ${truncatedMessage}`,
          mediaPath: m.mediaPath,
          mediaType: m.mediaType,
          shortcode: m.shortcode,
        };
      });
      if (isMounted.current) {
        setQuickAnswer(options);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (
      isString(inputMessage) &&
      !isEmpty(inputMessage) &&
      inputMessage.length >= 1
    ) {
      const firstWord = inputMessage.charAt(0);

      if (firstWord === "/") {
        setTypeBar(firstWord.indexOf("/") > -1);

        const filteredOptions = quickAnswers.filter(
          (m) => m.label.toLowerCase().indexOf(inputMessage.toLowerCase()) > -1
        );
        setTypeBar(filteredOptions);
      } else {
        setTypeBar(false);
      }
    } else {
      setTypeBar(false);
    }
  }, [inputMessage]);

  useEffect(() => {
    console.log("🔍 Modal state:", triggerFlowModalOpen, "Flow processing:", flowProcessing);

    // 🔥 RESET SIMPLES: Se modal fecha, libera campo
    if (!triggerFlowModalOpen && flowProcessing) {
      console.log("🔓 FORÇANDO liberação do campo");
      setFlowProcessing(false);
      flowProcessingRef.current = false;
    }
  }, [triggerFlowModalOpen, flowProcessing]);

  const disableOption = useCallback(() => {
    const isFlowProcessing = flowProcessingRef.current || flowProcessing;

    return (
      loading ||
      recording ||
      isFlowProcessing || // 🛡️ Usar tanto ref quanto estado
      (!isTicketPending() && ticketStatus !== "open" && ticketStatus !== "group")
    );
  }, [loading, recording, flowProcessing, ticketStatus]);

  const disableOptionForPending = useCallback(() => {
    const isFlowProcessing = flowProcessingRef.current || flowProcessing;

    return (
      loading ||
      recording ||
      isFlowProcessing || // 🛡️ Usar tanto ref quanto estado
      ticketStatus === "closed"
    );
  }, [loading, recording, flowProcessing, ticketStatus]);

  const handleUploadCamera = (blob) => {
    const isPrivate = privateMessage || isTicketPending();
    const filename = `${new Date().getTime()}.png`;
    sendMediaOptimistic({
      ticketId,
      isPrivate,
      items: [{ file: blob, fileName: filename, caption: "", mediaKind: "image" }],
      buildFormData: (items) => {
        const formData = new FormData();
        formData.append("body", isPrivate ? `\u200d` : "");
        formData.append("fromMe", true);
        items.forEach((item) => formData.append("medias", item.file, item.fileName));
        return formData;
      },
    });
  };

  // ✅ CORREÇÃO KISS: Apenas otimizar nome do arquivo para mobile
  const handleUploadAudio = async () => {
    setLoading(true);
    try {
      const [, blob] = await Mp3Recorder.stop().getMp3();
      if (blob.size < 10000) {
        setLoading(false);
        setRecording(false);
        return;
      }

      // ✅ CORREÇÃO: Nome do arquivo otimizado para mobile
      let filename;
      if (["whatsapp", "whatsapp_oficial"].includes(ticketChannel)) {
        // Para WhatsApp, usar formato mais compatível com mobile
        filename = isMobileDevice()
          ? `audio_${new Date().getTime()}.ogg`  // OGG para mobile
          : `audio_${new Date().getTime()}.mp3`; // MP3 para desktop
      } else {
        filename = `${new Date().getTime()}.m4a`;
      }

      const isPrivate = privateMessage || isTicketPending();
      sendMediaOptimistic({
        ticketId,
        isPrivate,
        items: [{ file: blob, fileName: filename, caption: "", voice: true }],
        buildFormData: (items) => {
          const formData = new FormData();
          formData.append("body", "🎵 Mensagem de voz");
          formData.append("fromMe", true);
          formData.append("isPrivate", isPrivate ? "true" : "false");
          // gravado na tela = mensagem de voz (o servidor não precisa adivinhar pelo nome)
          formData.append("isVoiceNote", "true");
          items.forEach((item) => formData.append("medias", item.file, item.fileName));
          return formData;
        },
      });
    } catch (err) {
      toastError(err);
    } finally {
      if (isMounted.current) {
        setLoading(false);
        setRecording(false);
      }
    }
  };

  // Fechar a prévia (clicando fora ou com Esc) descarta a seleção; antes os arquivos ficavam
  // retidos e o campo de mensagem sumia até trocar de conversa.
  const handleCloseModalMedias = () => {
    setMediasUpload([]);
    setShowModalMedias(false);
  };

  const handleCancelAudio = async () => {
    try {
      await Mp3Recorder.stop().getMp3();
      setRecording(false);
    } catch (err) {
      toastError(err);
    }
  };

  const handlePickFiles = (pickerRef) => {
    if (pickerRef.current) pickerRef.current.click();
    handleMenuItemClick();
  };

  const handleOpenMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event) => {
    setAnchorEl(null);
  };

  const handleSendContactModalOpen = async () => {
    handleMenuItemClick();
    setSenVcardModalOpen(true);
  };

  const handleCameraModalOpen = async () => {
    handleMenuItemClick();
    setModalCameraOpen(true);
  };

  const handleCancelSelection = () => {
    setMediasUpload([]);
    setShowModalMedias(false);
  };

  const checkForSelectedText = useCallback(() => {
    if (inputRef.current) {
      const start = inputRef.current.selectionStart;
      const end = inputRef.current.selectionEnd;

      if (start !== end && start !== null && end !== null) {
        const selectedText = inputMessage.substring(start, end);
        if (selectedText.trim() !== '') {
          // Para InputBase, calcular posição baseada no elemento
          const inputRect = inputRef.current.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          setSelectedText({
            text: selectedText,
            start: start,
            end: end
          });

          setFormatMenuAnchorPosition({
            x: inputRect.left + inputRect.width / 2,
            y: inputRect.top + scrollTop - 10 // Posicionar acima do input
          });

          return true;
        }
      }
    }

    setFormatMenuAnchorPosition(null);
    return false;
  }, [inputMessage]);

  const handleCloseFormatMenu = useCallback(() => {
    setFormatMenuAnchorPosition(null);
  }, []);

  // Aplica a formatação ao texto selecionado
  const handleFormatText = useCallback((formatType) => {
    const { text, start, end } = selectedText;
    let formattedText = '';

    switch (formatType) {
      case 'bold':
        formattedText = `*${text}*`;
        break;
      case 'italic':
        formattedText = `_${text}_`;
        break;
      case 'strikethrough':
        formattedText = `~${text}~`;
        break;
      case 'code':
        formattedText = `\`${text}\``;
        break;
      case 'numberedList':
        formattedText = text.split('\n')
          .map((line, index) => `${index + 1}. ${line}`)
          .join('\n');
        break;
      case 'bulletList':
        formattedText = text.split('\n')
          .map(line => `• ${line}`)
          .join('\n');
        break;
      case 'quote':
        formattedText = text.split('\n')
          .map(line => `> ${line}`)
          .join('\n');
        break;
      case 'clear':
        formattedText = text
          .replace(/\*([^*]+)\*/g, '$1')  // remove negrito
          .replace(/_([^_]+)_/g, '$1')    // remove itálico
          .replace(/~([^~]+)~/g, '$1')    // remove tachado
          .replace(/`([^`]+)`/g, '$1')    // remove código
          .replace(/^\d+\.\s/gm, '')      // remove numeração de lista
          .replace(/^•\s/gm, '')          // remove marcadores de lista
          .replace(/^>\s/gm, '');         // remove citação
        break;
      default:
        formattedText = text;
    }

    // Substitui o texto selecionado pelo texto formatado
    const newInputMessage =
      inputMessage.substring(0, start) +
      formattedText +
      inputMessage.substring(end);

    setInputMessage(newInputMessage);

    // Fecha o menu após a formatação
    handleCloseFormatMenu();

    // Define o foco e a posição do cursor após a operação
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
        const newCursorPosition = start + formattedText.length;
        inputRef.current.selectionStart = newCursorPosition;
        inputRef.current.selectionEnd = newCursorPosition;
      }
    }, 100);
  }, [selectedText, inputMessage, handleCloseFormatMenu]);

  // Handlers para detectar seleção de texto
  const handleSelectText = useCallback(() => {
    checkForSelectedText();
  }, [checkForSelectedText]);

  const handleMouseUp = useCallback(() => {
    checkForSelectedText();
  }, [checkForSelectedText]);

  const handleKeyUp = useCallback((e) => {
    // Teclas que podem alterar a seleção
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Shift') {
      checkForSelectedText();
    }
  }, [checkForSelectedText]);

  const renderReplyingMessage = (message) => {
    const isEditing = !replyingMessage && !!editingMessage;
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: message.fromMe,
            })}
          ></span>
          <div className={classes.replyginMsgBody}>
            <span
              className={clsx(classes.messageContactName, {
                [classes.messageSelfName]: message.fromMe,
              })}
            >
              {isEditing && <Create className={classes.replyginTitleIcon} />}
              {/* TODO i18n */}
              {isEditing
                ? "Editando mensagem"
                : message.fromMe
                  ? "Você"
                  : message.contact?.name}
            </span>
            <span className={classes.replyginMsgText}>
              <MentionText plain text={message.body} resolve={resolveQuotedMention} />
            </span>
          </div>
        </div>
        <IconButton
          aria-label={isEditing ? "Cancelar edição" : "Cancelar resposta"}
          className={classes.barButton}
          disabled={disableOptionForPending()}
          onClick={() => {
            setReplyingMessage(null);
            setEditingMessage(null);
            setInputMessage("");
          }}
        >
          <Clear />
        </IconButton>
      </div>
    );
  };

  const renderFlowProcessingAlert = () => {
    if (!flowProcessing) return null;

    return (
      <Box className={clsx(classes.pendingAlert, classes.flowAlert)} role="status">
        <CircularProgress size={16} />
        <span>
          <strong>Fluxo em Execução:</strong> Campo de mensagem temporariamente desabilitado.
        </span>
      </Box>
    );
  };

  const TextFormatMenu = () => {
    const isMenuOpen = Boolean(formatMenuAnchorPosition);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    if (!isMenuOpen) return null;

    return (
      <ClickAwayListener onClickAway={handleCloseFormatMenu}>
        <Fade in={isMenuOpen}>
          <div
            className={classes.floatingFormatMenu}
            style={{
              top: formatMenuAnchorPosition ? formatMenuAnchorPosition.y - 50 : 0,
              left: formatMenuAnchorPosition ? formatMenuAnchorPosition.x : 0,
            }}
          >
            <Tooltip title="Negrito">
              <IconButton
                aria-label="Negrito"
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('bold')}
                size="small"
              >
                <FormatBoldIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Itálico">
              <IconButton
                aria-label="Itálico"
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('italic')}
                size="small"
              >
                <FormatItalicIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Tachado">
              <IconButton
                aria-label="Tachado"
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('strikethrough')}
                size="small"
              >
                <FormatStrikethroughIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Código">
              <IconButton
                aria-label="Código"
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('code')}
                size="small"
              >
                <CodeIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Lista Numerada">
              <IconButton
                aria-label="Lista Numerada"
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('numberedList')}
                size="small"
              >
                <FormatListNumberedIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Lista com Marcadores">
              <IconButton
                aria-label="Lista com Marcadores"
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('bulletList')}
                size="small"
              >
                <FormatListBulletedIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Citação">
              <IconButton
                aria-label="Citação"
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('quote')}
                size="small"
              >
                <FormatQuoteIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Limpar Formatação">
              <IconButton
                aria-label="Limpar Formatação"
                className={classes.formatIconButton}
                disabled={disableOptionForPending()}
                onClick={() => handleFormatText('clear')}
                size="small"
              >
                <FormatClearIcon fontSize={isMobile ? "small" : "medium"} />
              </IconButton>
            </Tooltip>
          </div>
        </Fade>
      </ClickAwayListener>
    );
  };

  const renderPendingAlert = () => {
    if (!isTicketPending()) return null;

    return (
      <Box className={classes.pendingAlert} role="note">
        <Info style={{ fontSize: 18 }} />
        <span>
          <strong>Ticket Aguardando:</strong> Apenas mensagens internas são permitidas neste momento.
        </span>
      </Box>
    );
  };

  const internalMode = privateMessageInputVisible || isTicketPending();
  const attachDisabled = disableOption();
  const canTriggerFlow = ticketStatus === "open";
  const canSendVoucher = hotspotEnabled && ticketStatus === "open";
  const canSchedule = showSchedules && !isTicketPending() && !privateMessageInputVisible;
  const hasTools = canTriggerFlow || canSendVoucher || canSchedule;
  // Sem texto e fora do modo nota interna, o botão da direita é o microfone.
  const showSendButton =
    Boolean(inputMessage) ||
    showSelectMessageCheckbox ||
    (privateMessageInputVisible && !isTicketPending());

  const renderAttachIcon = (icon, color) => (
    <span
      className={classes.attachIcon}
      style={{
        color,
        backgroundColor: brandAlpha(color, theme.palette.type === "dark" ? 0.22 : 0.12),
      }}
      aria-hidden="true"
    >
      {icon}
    </span>
  );

  if (mediasUpload.length > 0 && showModalMedias) {
    return (
      <Paper
        elevation={0}
        square
        className={classes.viewMediaInputWrapper}
        onDragEnter={() => setOnDragEnter(true)}
        onDrop={(e) => handleInputDrop(e)}
      >
        {showModalMedias && (
          <MessageUploadMedias
            isOpen={showModalMedias}
            files={mediasUpload}
            onClose={handleCloseModalMedias}
            onSend={handleUploadMedia}
            onCancelSelection={handleCancelSelection}
          />
        )}
      </Paper>
    );
  } else {
    return (
      <>
        {templateModalOpen && (
          <TemplateModal
            open={templateModalOpen}
            handleClose={() => setTemplateModalOpen(false)}
            onSelectTemplate={(e) => handleSendMessageTemplate(e)}
            templates={templates}
          />
        )}
        {modalCameraOpen && (
          <CameraModal
            isOpen={modalCameraOpen}
            onRequestClose={() => setModalCameraOpen(false)}
            onCapture={handleCapture}
          />
        )}
        {senVcardModalOpen && (
          <ContactSendModal
            modalOpen={senVcardModalOpen}
            onClose={(c) => {
              handleSendContatcMessage(c);
            }}
          />
        )}
        {sendVoucherModalOpen && (
          <SendVoucherDialog
            open={sendVoucherModalOpen}
            ticketId={ticketId}
            onClose={() => setSendVoucherModalOpen(false)}
          />
        )}

        {/* NOVO MODAL DE TRIGGER FLOW */}
        {triggerFlowModalOpen && (
          <TriggerFlowModal
            open={triggerFlowModalOpen}
            onClose={handleTriggerFlowClose}
            ticketId={ticketId}
            ticketStatus={ticketStatus}
            onFlowTriggered={handleFlowTriggered}
            onFlowProcessing={handleFlowProcessing}
          />
        )}

        <div className={classes.mobileBarSpacer} style={{ height: barHeight }} aria-hidden="true" />
        <Paper
          square
          elevation={0}
          ref={barRef}
          className={classes.mainWrapper}
          onDragEnter={() => setOnDragEnter(true)}
          onDrop={(e) => handleInputDrop(e)}
        >
          {renderPendingAlert()}
          {renderFlowProcessingAlert()}

          {(replyingMessage && renderReplyingMessage(replyingMessage)) ||
            (editingMessage && renderReplyingMessage(editingMessage))}
          <div className={classes.newMessageBox}>
            {!isTicketPending() && (
              <>
                {/* Os seletores de arquivo ficam fora do menu: ele fecha antes de o arquivo ser escolhido. */}
                <input
                  multiple
                  type="file"
                  id="upload-img-button"
                  accept="image/*, video/*, audio/* "
                  className={classes.uploadInput}
                  onChange={handleChangeMedias}
                  ref={mediaInputRef}
                />
                <input
                  multiple
                  type="file"
                  id="upload-doc-button"
                  className={classes.uploadInput}
                  onChange={handleChangeMedias}
                  ref={docInputRef}
                />
                <IconButton
                  aria-label="Anexar"
                  aria-haspopup="true"
                  aria-controls="simple-menu"
                  className={clsx(classes.barButton, Boolean(anchorEl) && classes.barButtonOpen)}
                  disabled={attachDisabled && !(canSchedule && !loading)}
                  onClick={handleOpenMenuClick}
                >
                  <AddIcon />
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuItemClick}
                  getContentAnchorEl={null}
                  anchorOrigin={{ vertical: "top", horizontal: "left" }}
                  transformOrigin={{ vertical: "bottom", horizontal: "left" }}
                  classes={{ paper: classes.attachMenuPaper, list: classes.attachMenuList }}
                >
                  <MenuItem
                    className={classes.attachItem}
                    disabled={attachDisabled}
                    onClick={() => handlePickFiles(docInputRef)}
                  >
                    {renderAttachIcon(<Description />, "#7f66ff")}
                    Documento
                  </MenuItem>
                  <MenuItem
                    className={classes.attachItem}
                    disabled={attachDisabled}
                    onClick={() => handlePickFiles(mediaInputRef)}
                  >
                    {renderAttachIcon(<PermMedia />, "#007bfc")}
                    {i18n.t("messageInput.type.imageVideo")}
                  </MenuItem>
                  <MenuItem
                    className={classes.attachItem}
                    disabled={attachDisabled}
                    onClick={handleCameraModalOpen}
                  >
                    {renderAttachIcon(<CameraAlt />, "#ff2e74")}
                    {i18n.t("messageInput.type.cam")}
                  </MenuItem>
                  <MenuItem
                    className={classes.attachItem}
                    disabled={attachDisabled}
                    onClick={handleSendContactModalOpen}
                  >
                    {renderAttachIcon(<Person />, "#009de2")}
                    {i18n.t("messageInput.type.contact")}
                  </MenuItem>
                  <MenuItem
                    className={classes.attachItem}
                    disabled={attachDisabled}
                    onClick={() => {
                      handleMenuItemClick();
                      handleSendLinkVideo();
                    }}
                  >
                    {renderAttachIcon(<Duo />, "#02a698")}
                    {i18n.t("messageInput.type.meet")}
                  </MenuItem>
                  {useWhatsappOfficial && ticketChannel === "whatsapp_oficial" && (
                    <MenuItem
                      className={classes.attachItem}
                      disabled={attachDisabled}
                      onClick={() => {
                        handleMenuItemClick();
                        handleSendTemplate();
                      }}
                    >
                      {renderAttachIcon(<WhatsApp />, "#00a884")}
                      {i18n.t("messageInput.type.template")}
                    </MenuItem>
                  )}

                  {/* Ferramentas do sistema: ficam numa seção à parte, abaixo dos anexos. */}
                  {hasTools && (
                    <li className={classes.menuCaption} role="presentation">
                      Ferramentas
                    </li>
                  )}
                  {canTriggerFlow && (
                    <MenuItem
                      className={classes.attachItem}
                      disabled={attachDisabled}
                      onClick={() => {
                        handleMenuItemClick();
                        handleTriggerFlowClick();
                      }}
                    >
                      {renderAttachIcon(<AccountTree />, tokens.accent)}
                      Disparar fluxo
                    </MenuItem>
                  )}
                  {canSendVoucher && (
                    <MenuItem
                      className={classes.attachItem}
                      disabled={attachDisabled}
                      onClick={() => {
                        handleMenuItemClick();
                        setSendVoucherModalOpen(true);
                      }}
                    >
                      {renderAttachIcon(<WifiIcon />, tokens.accent)}
                      {i18n.t("hotspot.send.button")}
                    </MenuItem>
                  )}
                  {canSchedule && (
                    <MenuItem
                      className={classes.attachItem}
                      disabled={loading}
                      onClick={() => {
                        handleMenuItemClick();
                        setAppointmentModalOpen(true);
                      }}
                    >
                      {renderAttachIcon(<Timer />, tokens.accent)}
                      {i18n.t("tickets.buttons.scredule")}
                    </MenuItem>
                  )}
                </Menu>
              </>
            )}

            <IconButton
              aria-label="Emojis"
              aria-expanded={showEmoji}
              className={clsx(classes.barButton, classes.emojiButton)}
              disabled={isTicketPending() ? disableOptionForPending() : disableOption()}
              onClick={() => setShowEmoji((prevState) => !prevState)}
            >
              <Mood />
            </IconButton>
            {showEmoji ? (
              <div className={classes.emojiBox}>
                <ClickAwayListener onClickAway={() => setShowEmoji(false)}>
                  <Picker
                    perLine={isMobile ? 8 : 16}
                    theme={theme.palette.type === "dark" ? "dark" : "light"}
                    i18n={i18n}
                    showPreview={!isMobile}
                    showSkinTones={false}
                    onSelect={handleAddEmoji}
                  />
                </ClickAwayListener>
              </div>
            ) : null}

            <div
              className={clsx(
                classes.messageInputWrapper,
                internalMode && classes.messageInputWrapperInternal
              )}
            >
              <InputBase
                inputRef={(input) => {
                  input && input.focus();
                  input && (inputRef.current = input);
                }}
                className={clsx(
                  classes.messageInput,
                  isTicketPending() && classes.messageInputPending
                )}
                placeholder={
                  !internalMode
                    ? placeholderText
                    : isTicketPending()
                      ? "Mensagem interna (ticket aguardando aceite)..."
                      : ticketStatus === "open" || ticketStatus === "group"
                        ? i18n.t("messagesInput.placeholderPrivateMessage")
                        : i18n.t("messagesInput.placeholderClosed")
                }
                multiline
                maxRows={5}
                value={safeCapitalizeFirstLetter(inputMessage)}
                onChange={handleChangeInput}
                disabled={internalMode ? disableOptionForPending() : disableOption()}
                onPaste={(e) => {
                  (ticketStatus === "open" || ticketStatus === "group" || isTicketPending()) &&
                    handleInputPaste(e);
                }}
                onKeyDown={(e) => {
                  // com a lista de menções aberta, setas/Enter/Tab/Esc são dela
                  if (mention.onKeyDown(e)) return;
                  handleKeyDown(e);
                }}
                onKeyUp={(e) => {
                  if (["ArrowLeft", "ArrowRight", "Home", "End"].includes(e.key)) mention.track(e.target);
                  handleKeyUp(e);
                }}
                onMouseUp={(e) => {
                  mention.track(e.target);
                  handleMouseUp(e);
                }}
                onBlur={mention.close}
                onSelect={handleSelectText}
                onKeyPress={(e) => {
                  if (loading || e.shiftKey) return;
                  else if (e.key === "Enter" && !isNavigatingQuickAnswers) {
                    // o campo é esvaziado na hora; sem isto o Enter ainda inseria uma quebra de
                    // linha no campo já vazio
                    e.preventDefault();
                    handleSendMessage();
                  }
                }}
                spellCheck={true}
              />

              {/* Estados que o atendente precisa enxergar sem abrir menu: assinatura e nota interna. */}
              {signMessagePar && !isTicketPending() && (
                <Tooltip title={i18n.t("messageInput.tooltip.signature")}>
                  <IconButton
                    aria-label="Assinatura"
                    aria-pressed={signMessage === true}
                    className={clsx(classes.fieldToggle, signMessage === true && classes.fieldToggleOn)}
                    onClick={handleChangeSign}
                  >
                    <Create />
                  </IconButton>
                </Tooltip>
              )}
              {!isTicketPending() && (
                <Tooltip title={i18n.t("messageInput.tooltip.privateMessage")}>
                  <IconButton
                    aria-label="Nota interna"
                    aria-pressed={privateMessage === true}
                    className={clsx(classes.fieldToggle, privateMessage === true && classes.fieldToggleNote)}
                    onClick={handlePrivateMessage}
                  >
                    <Comment />
                  </IconButton>
                </Tooltip>
              )}

              {mention.open && (
                <MentionSuggest
                  suggestions={mention.suggestions}
                  activeIndex={mention.activeIndex}
                  onHover={mention.setActiveIndex}
                  onChoose={mention.choose}
                />
              )}

              {typeBar ? (
                <ul className={classes.messageQuickAnswersWrapper} ref={quickAnswersRef}>
                  {typeBar.map((value, index) => {
                    const isSelected = selectedQuickAnswerIndex === index;
                    return (
                      <li key={index}>
                        <div
                          className={clsx(
                            classes.quickAnswerItem,
                            isSelected && classes.quickAnswerItemSelected
                          )}
                          onClick={() => handleQuickAnswersClick(value)}
                        >
                          <Box className={classes.quickAnswerText}>
                            {value.label}
                          </Box>
                          {value.mediaType && (
                            <Chip
                              size="small"
                              label={`${getMediaTypeIcon(value.mediaType)} ${value.mediaType}`}
                              color={getMediaTypeColor(value.mediaType)}
                              className={classes.mediaTypeChip}
                            />
                          )}
                        </div>
                      </li>
                    );
                  })}

                  {typeBar.length > 4 && (
                    <li>
                      <div className={classes.quickAnswersScrollIndicator}>
                        {typeBar.length} respostas • use ↑↓ para navegar
                      </div>
                    </li>
                  )}
                </ul>
              ) : null}
            </div>

            {showSendButton ? (
              <Tooltip title={showSelectMessageCheckbox ? "Encaminhar" : "Enviar"}>
                <span className={classes.sendWrap}>
                  <IconButton
                    aria-label={showSelectMessageCheckbox ? "Encaminhar mensagens" : "Enviar mensagem"}
                    className={classes.sendButton}
                    onClick={
                      showSelectMessageCheckbox
                        ? handleOpenModalForward
                        : handleSendMessage
                    }
                    disabled={loading}
                  >
                    {showSelectMessageCheckbox ? (
                      <Reply className={classes.forwardIcon} />
                    ) : (
                      <Send className={classes.sendIcon} />
                    )}
                  </IconButton>
                </span>
              </Tooltip>
            ) : (
              <IconButton
                aria-label="Gravar áudio"
                className={classes.barButton}
                disabled={disableOptionForPending()}
                onClick={handleStartRecording}
              >
                <Mic />
              </IconButton>
            )}

            {/* Gravando: a barra inteira vira o gravador (lixeira, tempo, onda, pausar, enviar), como no WhatsApp. */}
            {recording && !showSendButton && (
              <AudioRecorderBar
                recorder={Mp3Recorder}
                busy={loading}
                onCancel={handleCancelAudio}
                onSend={handleUploadAudio}
              />
            )}

            {appointmentModalOpen && (
              <ScheduleModal
                open={appointmentModalOpen}
                onClose={() => setAppointmentModalOpen(false)}
                message={inputMessage}
                contactId={contactId}
                fromMessageInput={true}
                user={user}
              />
            )}

            {/* Menu de formatação que aparece quando texto é selecionado */}
            <TextFormatMenu />

          </div>
        </Paper>
      </>
    );
  }
};

export default MessageInput;
